module.exports = __webpack_public_path__ + "static/media/clinician-rhythm-preview@2x.317d8271.png";